import { Route } from 'react-router-dom';
import DashboardPage from '../pages/merchant-pages/dashboard.page';
import AdminBranchesPage from '../pages/admin-pages/admin-branches.page';
import PaymentLinksPage from '../pages/common-pages/payment-links.page';
import Logs from '../components/logs/logs.component';
import UserManagement from '../components/user-management/user-management.component';
import ViewAllPOS from '../components/pos/view-all-pos.component';
import CreateNewPos from '../components/pos/create-pos.component';
import MissingPage from '../pages/common-pages/missing.page';
import RefundApprovalPage from '../pages/auth-pages/refund-approval/refund-approval.page';

export const GlobalRoutes = () => {
  return (
    <>
      <Route path="/" />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="branches" element={<AdminBranchesPage />} />
      <Route path="create-payment-links" element={<PaymentLinksPage />} />
      <Route path="logs" element={<Logs />} />
      <Route path="users">
        <Route index element={<UserManagement />} />
      </Route>
      <Route path="pos">
        <Route index element={<ViewAllPOS />} />
        <Route path="create" element={<CreateNewPos />} />
      </Route>
      <Route path="*" element={<MissingPage />} />
      <Route path="refund">
        <Route index element={<RefundApprovalPage />} />
      </Route>
    </>
  );
};
